import {
  EMPLOYMENT_VALUES as EMPLOYMENT_TYPE_VALUES,
  UNEMPLOYMENT_REASONS as UNEMPLOYMENT_REASON_VALUES,
} from '@sravni/creditselection-customer-utils/lib/utils/customers';
import { useEffect } from 'react';

import type { TWorkplaceFormFields } from 'entities/creditForm';

import { useUpdateWorkFields } from 'features/UpdateWorkplaceInfo/lib/useUpdateWorkFields';

export const useClearUnnecessaryFields = (data: TWorkplaceFormFields) => {
  const { employmentType, unemploymentReason } = data;
  const { updateWorkFields } = useUpdateWorkFields();

  useEffect(() => {
    switch (employmentType?.value) {
      case EMPLOYMENT_TYPE_VALUES.RETIRED: {
        updateWorkFields({
          workOrganizationName: '',
          workAddress: null,
          workPhone: '',
          employerInn: '',
          areaOfEmployment: null,
          employerType: null,
          jobTitle: null,
          lastWorkExperienceStartMonth: '',
          unemploymentReason: null,
          anotherUnemploymentReason: '',
        });
        break;
      }
      case EMPLOYMENT_TYPE_VALUES.NOT_WORKING_VALUE: {
        updateWorkFields({
          workOrganizationName: '',
          workAddress: null,
          workPhone: '',
          employerInn: '',
          areaOfEmployment: null,
          employerType: null,
          jobTitle: null,
          lastWorkExperienceStartMonth: '',
          monthlySalary: '',
        });
        break;
      }
      case EMPLOYMENT_TYPE_VALUES.BUSINESS_OWNER: {
        updateWorkFields({
          jobTitle: null,
        });
        break;
      }
      default: {
        updateWorkFields({
          unemploymentReason: null,
          anotherUnemploymentReason: '',
        });
        break;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employmentType]);

  useEffect(() => {
    if (unemploymentReason?.value !== UNEMPLOYMENT_REASON_VALUES.OTHER) {
      updateWorkFields({ anotherUnemploymentReason: '' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unemploymentReason]);
};
